import dayjs from 'dayjs';

/**
 * 対象日がローカルタイムゾーンで本日と同じ日付の場合 true を返す。
 * null / 空文字 / 不正な日付の場合は false を返す。
 * @param targetDate 判定対象の日付
 */
export const isToday = (targetDate: Date | string | null | undefined): boolean => {
  if (targetDate === null || targetDate === undefined || targetDate === '') {
    return false;
  }
  const target = dayjs(targetDate);
  if (!target.isValid()) {
    return false;
  }
  return dayjs(new Date()).format('YYYYMMDD') === target.format('YYYYMMDD');
};

export default isToday;
